import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HomeFeed } from "components/home/HomeFeed";
import { LoginSplash } from "components/home/LoginSplash";
import { HomeTabSelector } from "components/home/HomeTabSelector";
import { PersonalFeed } from "components/home/PersonalFeed";
import { WithSideAds } from "components/ads";
import { IAppState } from "store/app-state";
import { HomepageSkyscraperEnum } from "components/ads/config/units/homepageSkyscraper";
import "./HomePage.scss";

const TRENDING_TAB = "Trending";
const PERSONAL_TAB = "For You";

export const HomePage = () => {
  const [tab, setTab] = useState<string>(TRENDING_TAB);
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const isUserLoggedIn = currentUser && (Object.entries(currentUser).length > 0);

  useEffect(() => {
    if (isUserLoggedIn) {
      setTab(PERSONAL_TAB);
    }
  }, [isUserLoggedIn]);

  useEffect(() => {
    document.title = "RedGIFs - Free Porn GIFs and Pics";
  }, []);

  const changeTab = (value: string): void => {
    setTab(value);
  };

  return (
    <WithSideAds
      leftAds={[
        HomepageSkyscraperEnum.HomepageSkyscraperL1,
      ]}
      rightAds={[
        HomepageSkyscraperEnum.HomepageSkyscraperR1,
      ]}
    >
      <div className="page homePage">
        <HomeTabSelector
          tab={tab}
          onChange={changeTab}
        />
        <Fragment>
          {tab === TRENDING_TAB && <HomeFeed />}
          {tab === PERSONAL_TAB && currentUser.username && <PersonalFeed />}
          {tab === PERSONAL_TAB && !currentUser.username && <LoginSplash />}
        </Fragment>
      </div>
    </WithSideAds>
  );
};
